import BugReport from './BugReport/logic'
import ChannelsLogic from './Channels/logic'
import CompaniesLogic from './Companies/logic'
import CountriesLogic from './Countries/logic'
import GroupLogic from './Group/logic'
import OmsOriginsLogic from './OmsOrigins/logic'
import OwnersLogic from './Owners/logic'
import SaleTypesLogic from './SaleTypes/logic'
import sharedLogic from './shared/logic'
import StoreLogic from './Store/logic'
import StoresLogic from './Stores/logic'
import SystemLogic from './System/logic'
import UserLogic from './User/logic'

export const logic = [
  ...BugReport,
  ...ChannelsLogic,
  ...CompaniesLogic,
  ...CountriesLogic,
  ...GroupLogic,
  ...OmsOriginsLogic,
  ...OwnersLogic,
  ...SaleTypesLogic,
  ...sharedLogic,
  ...StoreLogic,
  ...StoresLogic,
  ...SystemLogic,
  ...UserLogic,
]
